import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { DateTimeExtensions_toIso8601, Locale_get_FromSelectedLanguage, DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffffffZ, Byte_get_BytesPerMegaByte, Trie_empty, Trie_add, Trie_getSuggestions, classNames, DateTimeExtensions_toDateHHmm, delayAsync, createDebounce, Locale$reflection, Byte_ToString_Z3EC7497, stripHtmlTags, stackClasses, parseDecimal } from "../../Utils.js";
import * as react from "react";
import { fold, map } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { safeHash, equals as equals_1, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { useSelector } from "../../Redux/Store.js";
import { main, ButtonProps, ButtonProps_get_getDefault, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { join, printf, toText, isNullOrWhiteSpace } from "../../fable_modules/fable-library.3.7.20/String.js";
import { loadEffect, SaveStatus as SaveStatus_5, GlobalDependencies$reflection, LoadState$2, SaveStatus$reflection, LoadState$2$reflection, getTranslationFrom } from "../../Global.js";
import { empty as empty_1, map as map_3, toArray, append, singleton, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { Size, SveaIcon, renderSveaIconBySize, textDotsLoading, getWrappedMaterialIcon, dotsLoading } from "../../ViewUtils.js";
import { warning, success, error } from "../../Components/Message/Message.js";
import { exists, collect, tryFind, iterate, tryHead, mapIndexed, empty, singleton as singleton_2, cons, map as map_2, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { effect } from "../../Components/Hooks/ClickOutside.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { Service, ProviderServices_GetServiceKind_50594B0D, DataPackageUsage, TopupUsage, ProviderServices_OfDto_Z4FEEBB20, BarringViewModel, DataPackageViewModel, TopupViewModel, BarringStatus, BarringStatus$reflection, ValidateIcc$reflection, TopupPackage$reflection, TopupUsage$reflection, DataPackageUsage$reflection, DataPackage$reflection } from "./Model.js";
import { bool_type, equals, tuple_type, class_type, array_type, int32_type, record_type, lambda_type, unit_type, list_type, string_type, option_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Product$reflection, IsoCountryCode$reflection } from "../../DomainTypes.js";
import { bind, value as value_8, map as map_1, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { DateOptions, DateOptions_get_getDefault, inputDate, SelectOption, ValueProp, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { renderWithButtonProps, render as render_1 } from "../../Components/Modals/Standard.js";
import { ModalSize } from "../../Components/Modal/Modal.js";
import { date as date_2, now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_2 } from "../../Components/StatefulFormFields/Text.js";
import { IccModule_create, PhoneNumber__get_Value, PhoneNumberModule_create } from "../../Validation/Telecom.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { MinimumDate, EnableTimePicker, TimeTwentyFour, OnChange as OnChange_2, Value as Value_2, Locale, FormatDateBy, Id as Id_5 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { SwitchProps, SwitchProps_get_GetDefault, render as render_3 } from "../../Components/Switch/Switch.js";
import { NumberHistory_IsActive_Z5E3A5CDD, NumberHistoryDTO_SortByActiveFrom_285C6A16, NumberHistory_OfDTO, Sim$reflection } from "../Subscriptions/Common.js";
import { MobileApi_saveChangeIcc, BarringApi_saveStatus, MobileApi_saveActivateWithIcc, MobileApi_ActivateBody, MobileApi_Item, TopupApi_savePackage, GeneralApi_loadAllStatuses, DataPackageApi_loadUsage, DataPackageApi_loadCurrent, TopupApi_loadUsage, TopupApi_loadPackages, Api_loadProviderServices, Api_loadSim, Api_loadNumberHistory, BarringApi_loadStatus, Api_loadValidateIcc, Api_loadIccNumbers } from "./Api.js";
import { fromBits, compare, fromNumber } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { op_Multiply, toNumber } from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import Decimal from "../../fable_modules/fable-library.3.7.20/Decimal.js";
import { List_distinct } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { usesProvisioningViaSvea as usesProvisioningViaSvea_1 } from "../Telecom/Common.js";
import { PortationBoxProps, RenderStyle, renderPortationBox } from "../Portation/PortationBox.js";
import { UTCModule_addYears, UTCModule_today, UTCModule_addMonths } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import "../../../src/Containers/SimpleOrder/View.scss";


const renderIccSuggestions = FunctionComponent_Of_Z5A158BBF((props) => {
    let getIccSuggestionsFn, children_3;
    let suggestions;
    const input = props.IccValue;
    const matchValue = [parseDecimal(props.IccValue), props.GetIccSuggestionsFn, input.length];
    let pattern_matching_result, getIccSuggestionsFn_1, x_1;
    if (matchValue[0] != null) {
        if (matchValue[1] != null) {
            if ((getIccSuggestionsFn = matchValue[1], matchValue[2] > 0)) {
                pattern_matching_result = 0;
                getIccSuggestionsFn_1 = matchValue[1];
                x_1 = matchValue[2];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            suggestions = getIccSuggestionsFn_1(input);
            break;
        }
        case 1: {
            suggestions = [];
            break;
        }
    }
    if (suggestions.length === 0) {
        return react.createElement(react.Fragment, {});
    }
    else {
        const children_5 = [(children_3 = map((number) => react.createElement("li", {
            className: "list__item",
            onClick: (_arg) => {
                props.OnClick(number);
            },
        }, number), suggestions), react.createElement("ul", {
            className: "search-result__list",
        }, ...children_3))];
        return react.createElement("div", {
            className: "change-icc__search-result",
        }, ...children_5);
    }
}, "IccSuggestions", uncurry(2, void 0), void 0, "renderIccSuggestions", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 40);

const renderIccValidation = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, Disabled, arg;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const buttonHtml = wrappedButton(new ButtonKind(0), (inputRecord = ButtonProps_get_getDefault(), (Disabled = (isNullOrWhiteSpace(props.IccValue) ? true : (parseDecimal(props.IccValue) == null)), new ButtonProps((arg = getTranslationFrom(translationsLoadState, "Common.Validate"), toText(printf("%s ICC"))(arg)), inputRecord.Content, (_arg) => {
        props.ValidateIccFn(props.IccValue);
    }, Disabled, "verify-icc-btn", inputRecord.SaveStatus, inputRecord.HTMLProps, inputRecord.ExtraClasses, inputRecord.Icon))));
    let validateIccMessageHtml;
    const children_1 = toList(delay(() => {
        const matchValue = props.ValidateIcc;
        switch (matchValue.tag) {
            case 1: {
                return singleton(dotsLoading);
            }
            case 3: {
                return singleton(error(matchValue.fields[0].split("")));
            }
            case 2: {
                const iccValidation = matchValue.fields[0];
                return iccValidation.IsSuccess ? singleton(success(iccValidation.Message.split(""))) : singleton(warning(iccValidation.Message.split("")));
            }
            default: {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }
    }));
    validateIccMessageHtml = react.createElement("div", {
        className: "validate__message",
    }, ...children_1);
    return react.createElement("div", {
        className: "change-icc__validate",
    }, buttonHtml, validateIccMessageHtml);
}, "IccValidation", uncurry(2, void 0), void 0, "renderIccValidation", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 79);

const loadingBoxHtml = (() => {
    const props = [new HTMLAttr(65, stackClasses(ofArray(["simple-order__container", "p-5", "m-1"])))];
    return react.createElement("div", keyValueList(props, 1), dotsLoading);
})();

function renderErrorBox(header, msg) {
    let props_2, children_2, props;
    const children_4 = [(props_2 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between", "align-items-center", "mb-3"])))], (children_2 = [(props = [new HTMLAttr(65, stackClasses(ofArray(["mb-0", "font-weight-bold"])))], react.createElement("h6", keyValueList(props, 1), header))], react.createElement("div", keyValueList(props_2, 1), ...children_2))), error(msg.split(""))];
    return react.createElement("div", {
        className: "simple-order__container",
    }, ...children_4);
}

function renderErrorModal(getTranslation, msg, closeFn) {
    let children;
    return renderAsModal("Error", (children = [stripHtmlTags(msg)], react.createElement("div", {}, ...children)), new MessageType(2), getTranslation("Common.Close"), closeFn);
}

const renderRedCircle = FunctionComponent_Of_Z5A158BBF((props) => {
    const showMessageState = react.useState(false);
    const containerRef = react.useRef(void 0);
    react.useEffect(() => {
        const disp = (() => effect(containerRef, () => {
        showMessageState[1](false);
    }, void 0))();
        return () => disp.Dispose();
    });
    let msgBoxHtml;
    const matchValue = showMessageState[0];
    msgBoxHtml = (matchValue ? react.createElement("div", {
        className: "error-circle__msg",
    }, props.Message) : react.createElement(react.Fragment, {}));
    const children_3 = [getWrappedMaterialIcon("info"), msgBoxHtml];
    return react.createElement("div", {
        ref: containerRef,
        className: "simple-order__error-circle",
        onClick: (_arg) => {
            showMessageState[1]((value) => (!value));
        },
    }, ...children_3);
}, "RedCircle", Helpers_equalsButFunctions, void 0, "renderRedCircle", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 135);

class DataBoxProps extends Record {
    constructor(CurrentPackage, DataPackageUsage, DataPackagePackages, DataPackageSelectedPackage, DataPackagePackageSaveStatus, TopupUsage, TopupPackages, TopupSelectedPackage, TopupPackageSaveStatus, IsoCountryCode, SaveTopupPackageFn, ResetTopupSavePackageFn) {
        super();
        this.CurrentPackage = CurrentPackage;
        this.DataPackageUsage = DataPackageUsage;
        this.DataPackagePackages = DataPackagePackages;
        this.DataPackageSelectedPackage = DataPackageSelectedPackage;
        this.DataPackagePackageSaveStatus = DataPackagePackageSaveStatus;
        this.TopupUsage = TopupUsage;
        this.TopupPackages = TopupPackages;
        this.TopupSelectedPackage = TopupSelectedPackage;
        this.TopupPackageSaveStatus = TopupPackageSaveStatus;
        this.IsoCountryCode = IsoCountryCode;
        this.SaveTopupPackageFn = SaveTopupPackageFn;
        this.ResetTopupSavePackageFn = ResetTopupSavePackageFn;
    }
}

function DataBoxProps$reflection() {
    return record_type("Containers.SimpleOrder.View.DataBoxProps", [], DataBoxProps, () => [["CurrentPackage", LoadState$2$reflection(option_type(DataPackage$reflection()), string_type)], ["DataPackageUsage", LoadState$2$reflection(DataPackageUsage$reflection(), string_type)], ["DataPackagePackages", LoadState$2$reflection(list_type(DataPackage$reflection()), string_type)], ["DataPackageSelectedPackage", string_type], ["DataPackagePackageSaveStatus", SaveStatus$reflection()], ["TopupUsage", LoadState$2$reflection(TopupUsage$reflection(), string_type)], ["TopupPackages", LoadState$2$reflection(list_type(TopupPackage$reflection()), string_type)], ["TopupSelectedPackage", string_type], ["TopupPackageSaveStatus", SaveStatus$reflection()], ["IsoCountryCode", IsoCountryCode$reflection()], ["SaveTopupPackageFn", lambda_type(string_type, unit_type)], ["ResetTopupSavePackageFn", lambda_type(unit_type, unit_type)]]);
}

const renderDataBox = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, arg, arg_1, arg_3, arg_6, inputRecord, arg_8, inputRecord_1, OptionValues, arg_10, children_58, children_56;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const addTopupModalIsOpenState = react.useState(false);
    let dataPackageSectionHtml;
    let headerHtml;
    let redErrorCircleHtml;
    const matchValue = props.DataPackageUsage;
    switch (matchValue.tag) {
        case 1:
        case 2: {
            redErrorCircleHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 3: {
            redErrorCircleHtml = renderRedCircle({
                Message: matchValue.fields[0],
            });
            break;
        }
        default: {
            redErrorCircleHtml = react.createElement(react.Fragment, {});
        }
    }
    const props_4 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between"])))];
    const children_3 = [(children_1 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.DataPackage")], react.createElement("div", {
        className: "font-weight-bold",
    }, ...children_1)), redErrorCircleHtml];
    headerHtml = react.createElement("div", keyValueList(props_4, 1), ...children_3);
    let nameHtml;
    let labelHtml;
    const children_5 = [(arg = getTranslation("Common.Name"), toText(printf("%s: "))(arg))];
    labelHtml = react.createElement("span", {
        ["data-translation"]: "Common.Name",
    }, ...children_5);
    let valueHtml;
    const matchValue_1 = props.CurrentPackage;
    switch (matchValue_1.tag) {
        case 1: {
            valueHtml = textDotsLoading;
            break;
        }
        case 3: {
            const children_8 = [renderRedCircle({
                Message: matchValue_1.fields[0],
            })];
            valueHtml = react.createElement("span", {}, ...children_8);
            break;
        }
        case 2: {
            const name = defaultArg(map_1((p) => p.Name, matchValue_1.fields[0]), "-");
            valueHtml = react.createElement("span", {}, name);
            break;
        }
        default: {
            valueHtml = react.createElement(react.Fragment, {});
        }
    }
    nameHtml = react.createElement("div", {}, labelHtml, valueHtml);
    let usageSectionHtml;
    const matchValue_2 = props.DataPackageUsage;
    switch (matchValue_2.tag) {
        case 1: {
            usageSectionHtml = textDotsLoading;
            break;
        }
        case 3: {
            usageSectionHtml = react.createElement(react.Fragment, {});
            break;
        }
        case 2: {
            const usage = matchValue_2.fields[0];
            let remainingSurfHtml;
            let labelHtml_1;
            const children_16 = [(arg_1 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SurfRemaining"), toText(printf("%s: "))(arg_1))];
            labelHtml_1 = react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Telecom.SurfRemaining",
            }, ...children_16);
            const valueHtml_1 = defaultArg(map_1((bytes) => {
                const children_18 = [Byte_ToString_Z3EC7497(bytes)];
                return react.createElement("span", {}, ...children_18);
            }, usage.RemainingBytes), "-");
            remainingSurfHtml = react.createElement("div", {}, labelHtml_1, valueHtml_1);
            let surfLimitHtml;
            let labelHtml_2;
            const children_22 = [(arg_3 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SurfLimit"), toText(printf("%s: "))(arg_3))];
            labelHtml_2 = react.createElement("span", {
                ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Telecom.SurfLimit",
            }, ...children_22);
            const valueHtml_2 = defaultArg(map_1((bytes_1) => {
                const children_24 = [Byte_ToString_Z3EC7497(bytes_1)];
                return react.createElement("span", {}, ...children_24);
            }, usage.LimitBytes), "-");
            surfLimitHtml = react.createElement("div", {}, labelHtml_2, valueHtml_2);
            let rolloverHtml;
            if (props.IsoCountryCode.ThreeLetter.toLocaleUpperCase() === "NOR") {
                const labelHtml_3 = react.createElement("span", {}, "Rollover: ");
                const valueHtml_3 = defaultArg(map_1((bytes_2) => {
                    const children_30 = [Byte_ToString_Z3EC7497(bytes_2)];
                    return react.createElement("span", {}, ...children_30);
                }, usage.RolloverBytes), getTranslation("Common.Nothing"));
                rolloverHtml = react.createElement("div", {}, labelHtml_3, valueHtml_3);
            }
            else {
                rolloverHtml = react.createElement(react.Fragment, {});
            }
            usageSectionHtml = react.createElement(react.Fragment, {}, remainingSurfHtml, surfLimitHtml, rolloverHtml);
            break;
        }
        default: {
            usageSectionHtml = react.createElement(react.Fragment, {});
        }
    }
    dataPackageSectionHtml = react.createElement("div", {
        className: "container__section",
    }, headerHtml, nameHtml, usageSectionHtml);
    let topupSectionHtml;
    let redErrorCircleHtml_1;
    const matchValue_4 = props.TopupUsage;
    switch (matchValue_4.tag) {
        case 1:
        case 2: {
            redErrorCircleHtml_1 = react.createElement(react.Fragment, {});
            break;
        }
        case 3: {
            redErrorCircleHtml_1 = renderRedCircle({
                Message: matchValue_4.fields[0],
            });
            break;
        }
        default: {
            redErrorCircleHtml_1 = react.createElement(react.Fragment, {});
        }
    }
    let remainingSurfHtml_1;
    let labelHtml_4;
    const children_39 = [(arg_6 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SurfRemaining"), toText(printf("%s: "))(arg_6))];
    labelHtml_4 = react.createElement("span", {}, ...children_39);
    let valueHtml_4;
    const matchValue_5 = props.TopupUsage;
    switch (matchValue_5.tag) {
        case 1: {
            valueHtml_4 = textDotsLoading;
            break;
        }
        case 3: {
            valueHtml_4 = react.createElement(react.Fragment, {});
            break;
        }
        case 2: {
            valueHtml_4 = defaultArg(map_1((bytes_3) => {
                const children_42 = [Byte_ToString_Z3EC7497(bytes_3)];
                return react.createElement("span", {}, ...children_42);
            }, matchValue_5.fields[0].RemainingBytes), "-");
            break;
        }
        default: {
            valueHtml_4 = textDotsLoading;
        }
    }
    remainingSurfHtml_1 = react.createElement("div", {}, labelHtml_4, valueHtml_4);
    let headerHtml_1;
    const props_49 = [new HTMLAttr(65, stackClasses(ofArray(["font-weight-bold", "d-flex", "justify-content-between"])))];
    const children_48 = [react.createElement("div", {
        className: "font-weight-bold",
    }, "Topup"), redErrorCircleHtml_1];
    headerHtml_1 = react.createElement("div", keyValueList(props_49, 1), ...children_48);
    topupSectionHtml = react.createElement("div", {
        className: "container__section",
    }, headerHtml_1, remainingSurfHtml_1);
    const addTopupButtonHtml = main((inputRecord = ButtonProps_get_getDefault(), new ButtonProps((arg_8 = getTranslation("Common.Add"), toText(printf("%s Topup"))(arg_8)), inputRecord.Content, (_arg) => {
        addTopupModalIsOpenState[1](true);
    }, inputRecord.Disabled, "open-topup-modal-btn", props.TopupPackageSaveStatus, inputRecord.HTMLProps, inputRecord.ExtraClasses, inputRecord.Icon)));
    let addTopupModalHtml;
    const selectedTopupPackageState = react.useState("");
    let bodyHtml;
    let packageSelectHtml;
    const matchValue_6 = props.TopupPackages;
    switch (matchValue_6.tag) {
        case 1: {
            packageSelectHtml = dotsLoading;
            break;
        }
        case 3: {
            packageSelectHtml = error(matchValue_6.fields[0].split(""));
            break;
        }
        case 2: {
            const optionValues = map_2((p_1) => [p_1.Id, p_1.Name], matchValue_6.fields[0]);
            packageSelectHtml = selectOption((inputRecord_1 = SelectOption_get_getDefault(), (OptionValues = cons(["", getTranslation("Common.Choose")], optionValues), new SelectOption(new ValueProp(0, selectedTopupPackageState[0], (e) => {
                const arg_9 = Browser_Types_Event__Event_get_Value(e);
                selectedTopupPackageState[1](arg_9);
            }), "topup-package-select", OptionValues, inputRecord_1.Classes, inputRecord_1.LabelText, inputRecord_1.Disabled, inputRecord_1.HTMLProps))));
            break;
        }
        default: {
            packageSelectHtml = react.createElement(react.Fragment, {});
        }
    }
    bodyHtml = react.createElement("div", {}, packageSelectHtml);
    addTopupModalHtml = render_1(addTopupModalIsOpenState[0], new ModalSize(0), (arg_10 = getTranslation("Common.Add"), toText(printf("%s Topup"))(arg_10)), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Add"), (_arg_1) => {
        addTopupModalIsOpenState[1](false);
    }, (_arg_2) => {
        if ((selectedTopupPackageState[0]) === "") {
        }
        else {
            props.SaveTopupPackageFn(selectedTopupPackageState[0]);
            addTopupModalIsOpenState[1](false);
        }
    });
    let errorModalHtml;
    const matchValue_8 = props.TopupPackageSaveStatus;
    errorModalHtml = ((matchValue_8.tag === 3) ? renderErrorModal(getTranslation, matchValue_8.fields[0].split(""), (_arg_3) => {
        props.ResetTopupSavePackageFn();
    }) : react.createElement(react.Fragment, {}));
    const containerClasses = stackClasses(ofArray(["simple-order__set-width", "simple-order__container", "justify-content-between"]));
    const children_62 = [(children_58 = [(children_56 = [getTranslation("Common.Data")], react.createElement("h6", {
        className: "font-weight-bold",
    }, ...children_56)), dataPackageSectionHtml, topupSectionHtml], react.createElement("div", {
        className: "mb-3",
    }, ...children_58)), react.createElement("div", {
        className: "container__actions",
    }, addTopupButtonHtml, addTopupModalHtml), errorModalHtml];
    return react.createElement("div", {
        className: containerClasses,
    }, ...children_62);
}, "DataBox", Helpers_equalsButFunctions, void 0, "renderDataBox", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 374);

class ActivationProps extends Record {
    constructor(ClientNr, Locale, GetIccSuggestionsFn, ValidateIcc, ValidateIccFn, ValidateIccResetFn, SaveActivateFn, LoadIccNumbersFn, ActivationSaveStatus) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.Locale = Locale;
        this.GetIccSuggestionsFn = GetIccSuggestionsFn;
        this.ValidateIcc = ValidateIcc;
        this.ValidateIccFn = ValidateIccFn;
        this.ValidateIccResetFn = ValidateIccResetFn;
        this.SaveActivateFn = SaveActivateFn;
        this.LoadIccNumbersFn = LoadIccNumbersFn;
        this.ActivationSaveStatus = ActivationSaveStatus;
    }
}

function ActivationProps$reflection() {
    return record_type("Containers.SimpleOrder.View.ActivationProps", [], ActivationProps, () => [["ClientNr", int32_type], ["Locale", Locale$reflection()], ["GetIccSuggestionsFn", option_type(lambda_type(string_type, array_type(string_type)))], ["ValidateIcc", LoadState$2$reflection(ValidateIcc$reflection(), string_type)], ["ValidateIccFn", lambda_type(string_type, unit_type)], ["ValidateIccResetFn", lambda_type(unit_type, unit_type)], ["SaveActivateFn", lambda_type(tuple_type(string_type, string_type, class_type("System.DateTime")), unit_type)], ["LoadIccNumbersFn", lambda_type(unit_type, unit_type)], ["ActivationSaveStatus", SaveStatus$reflection()]]);
}

const renderActivation = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, inputRecord_1, inputRecord_2, LabelText_2, copyOfStruct, matchValue_6, inputRecord_5, children_20, props_17, children_16, children_18;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalIsOpenState = react.useState(false);
    const numberState = react.useState("");
    const iccState = react.useState("");
    const inputIccIsFocusedState = react.useState(false);
    const activationDateState = react.useState(now());
    const numberCategoryState = react.useState(new LoadState$2(0));
    const debounce1000ms = createDebounce(1000);
    react.useEffect(() => {
        numberState[1]("");
        iccState[1]("");
        inputIccIsFocusedState[1](false);
        activationDateState[1](now());
        numberCategoryState[1](new LoadState$2(0));
        props.ValidateIccResetFn();
    }, [modalIsOpenState[0]]);
    let modalHtml;
    let numberInputRowHtml;
    const numberInputHtml = render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(numberState[0], inputRecord.Type, inputRecord.Classes, (e) => {
        const arg_5 = Browser_Types_Event__Event_get_Value(e);
        numberState[1](arg_5);
        debounce1000ms(() => {
            let number;
            const matchValue_3 = PhoneNumberModule_create(getTranslation, Browser_Types_Event__Event_get_Value(e));
            if (matchValue_3.tag === 1) {
            }
            else {
                startImmediate((number = PhoneNumber__get_Value(matchValue_3.fields[0]), singleton_1.Delay(() => {
                    let matchValue, parseFn, arg_2;
                    numberCategoryState[1](new LoadState$2(1));
                    const url = toText(printf("/Telecom/NumberCategory/%i/%s"))(props.ClientNr)(number);
                    return singleton_1.Bind((matchValue = ValidatedUrlModule_create(new UrlKind(0, url)), (matchValue.tag === 1) ? singleton_1.Return(new FSharpResult$2(1, matchValue.fields[0])) : ((parseFn = ((arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0)), (arg_1_1) => {
                        const str = arg_1_1;
                        return equals(option_type(string_type), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(option_type(string_type), arg_2, Http_get_ExtraCoders().Value)), str);
                    })), singleton_1.Delay(() => singleton_1.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
                        let response_1;
                        return singleton_1.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(option_type(string_type), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
                    }))))), (_arg_1) => {
                        const data = _arg_1;
                        const updatedData = (data.tag === 1) ? (new LoadState$2(3, data.fields[0])) : (new LoadState$2(2, data.fields[0]));
                        numberCategoryState[1](updatedData);
                        return singleton_1.Zero();
                    });
                })));
            }
        });
    }, inputRecord.Disabled, getTranslation("Common.PhoneNumber"), "activate-number-input", (str_1) => PhoneNumberModule_create(getTranslation, str_1), inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)));
    let numberCategoryInfoHtml;
    const children_5 = toList(delay(() => {
        let children, arg_7;
        const matchValue_4 = numberCategoryState[0];
        let pattern_matching_result, numberCategory_1;
        if (matchValue_4.tag === 1) {
            pattern_matching_result = 0;
        }
        else if (matchValue_4.tag === 2) {
            if (matchValue_4.fields[0] != null) {
                if (!isNullOrWhiteSpace(matchValue_4.fields[0])) {
                    pattern_matching_result = 1;
                    numberCategory_1 = matchValue_4.fields[0];
                }
                else {
                    pattern_matching_result = 2;
                }
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
        switch (pattern_matching_result) {
            case 0: {
                return singleton(dotsLoading);
            }
            case 1: {
                return append(singleton((children = [(arg_7 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.NumberCategory"), toText(printf("%s:"))(arg_7))], react.createElement("div", {
                    className: "category__heading",
                }, ...children))), delay(() => singleton(react.createElement("div", {
                    className: "category__value ",
                }, numberCategory_1))));
            }
            case 2: {
                return singleton(react.createElement(react.Fragment, {}));
            }
        }
    }));
    numberCategoryInfoHtml = react.createElement("div", {
        className: "number__category",
    }, ...children_5);
    numberInputRowHtml = react.createElement("div", {
        className: "number",
    }, numberInputHtml, numberCategoryInfoHtml);
    let iccHtml;
    const iccInputHtml = render_2()((inputRecord_1 = TextProps$1_GetDefault(), new TextProps$1(iccState[0], inputRecord_1.Type, inputRecord_1.Classes, (e_1) => {
        const arg_8 = Browser_Types_Event__Event_get_Value(e_1);
        iccState[1](arg_8);
    }, inputRecord_1.Disabled, "ICC", "activate-icc-input", (str_2) => IccModule_create(getTranslation, str_2), inputRecord_1.DynamicWidth, inputRecord_1.HTMLProps, (_arg_3) => {
        startImmediate(delayAsync(500, () => {
            inputIccIsFocusedState[1](false);
        }));
    }, (_arg_2) => {
        inputIccIsFocusedState[1](true);
    }, "off", inputRecord_1.Name)));
    let iccSuggestionsHtml;
    const matchValue_5 = inputIccIsFocusedState[0];
    iccSuggestionsHtml = (matchValue_5 ? renderIccSuggestions({
        GetIccSuggestionsFn: props.GetIccSuggestionsFn,
        IccValue: iccState[0],
        OnClick: (number_1) => {
            iccState[1](number_1);
            inputIccIsFocusedState[1](false);
        },
    }) : react.createElement(react.Fragment, {}));
    const validateIccHtml = renderIccValidation({
        IccValue: iccState[0],
        ValidateIcc: props.ValidateIcc,
        ValidateIccFn: props.ValidateIccFn,
    });
    iccHtml = react.createElement("div", {
        className: "container__change-icc",
    }, iccInputHtml, iccSuggestionsHtml, validateIccHtml);
    let activationDateInputHtml;
    const children_12 = [inputDate((inputRecord_2 = DateOptions_get_getDefault(), (LabelText_2 = getTranslation("Common.Date"), new DateOptions(ofArray([Id_5("activate-date-input"), FormatDateBy((date) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date)), Locale(props.Locale.FlatpickrLocale), Value_2(activationDateState[0]), OnChange_2((arg_11) => {
        activationDateState[1](arg_11);
    }), TimeTwentyFour(true), EnableTimePicker(true), MinimumDate((copyOfStruct = now(), date_2(copyOfStruct)))]), LabelText_2, true, inputRecord_2.Disabled, inputRecord_2.OnClearClick))))];
    activationDateInputHtml = react.createElement("div", {
        className: "fit-content",
    }, ...children_12);
    const bodyHtml = react.createElement("div", {
        className: "activation-form",
    }, iccHtml, numberInputRowHtml, activationDateInputHtml);
    let cancelButtonProps;
    const inputRecord_3 = ButtonProps_get_getDefault();
    cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_3.Content, (_arg_4) => {
        modalIsOpenState[1](false);
    }, inputRecord_3.Disabled, "activate-cancel-button", inputRecord_3.SaveStatus, inputRecord_3.HTMLProps, inputRecord_3.ExtraClasses, inputRecord_3.Icon));
    let acceptButtonProps;
    const inputRecord_4 = ButtonProps_get_getDefault();
    acceptButtonProps = (new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Activate"), inputRecord_4.Content, (_arg_5) => {
        props.SaveActivateFn([iccState[0], numberState[0], activationDateState[0]]);
        modalIsOpenState[1](false);
    }, (matchValue_6 = [props.ValidateIcc, PhoneNumberModule_create(getTranslation, numberState[0])], (matchValue_6[0].tag === 2) ? ((matchValue_6[1].tag === 0) ? (!matchValue_6[0].fields[0].IsSuccess) : true) : true), "activate-accept-button", inputRecord_4.SaveStatus, inputRecord_4.HTMLProps, inputRecord_4.ExtraClasses, inputRecord_4.Icon));
    modalHtml = renderWithButtonProps(modalIsOpenState[0], new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.CreateActivation"), bodyHtml, cancelButtonProps, acceptButtonProps);
    const activateButtonHtml = main((inputRecord_5 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.CreateActivation"), inputRecord_5.Content, (_arg_6) => {
        modalIsOpenState[1](true);
        props.LoadIccNumbersFn();
    }, inputRecord_5.Disabled, "activate-create-button", props.ActivationSaveStatus, inputRecord_5.HTMLProps, inputRecord_5.ExtraClasses, inputRecord_5.Icon)));
    const props_23 = [new HTMLAttr(65, stackClasses(ofArray(["simple-order__container", "simple-order__set-height", "simple-order__set-width", "justify-content-between"])))];
    const children_22 = [(children_20 = [(props_17 = [new HTMLAttr(65, stackClasses(ofArray(["mb-3", "font-weight-bold"]))), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Telecom.Activate"]], (children_16 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Activate")], react.createElement("h6", keyValueList(props_17, 1), ...children_16))), (children_18 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ActivateIngress")], react.createElement("p", {}, ...children_18))], react.createElement("div", {
        className: "container__actions",
    }, ...children_20)), activateButtonHtml, modalHtml];
    return react.createElement("div", keyValueList(props_23, 1), ...children_22);
}, "ActivationBox", Helpers_equalsButFunctions, void 0, "renderActivation", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 597);

class BarringProps extends Record {
    constructor(IsEditing, ServerValues, UserValues, SaveStatus, SaveBarringStatusFn, ResetSaveStatusFn, SetIsEditingFn) {
        super();
        this.IsEditing = IsEditing;
        this.ServerValues = ServerValues;
        this.UserValues = UserValues;
        this.SaveStatus = SaveStatus;
        this.SaveBarringStatusFn = SaveBarringStatusFn;
        this.ResetSaveStatusFn = ResetSaveStatusFn;
        this.SetIsEditingFn = SetIsEditingFn;
    }
}

function BarringProps$reflection() {
    return record_type("Containers.SimpleOrder.View.BarringProps", [], BarringProps, () => [["IsEditing", bool_type], ["ServerValues", LoadState$2$reflection(BarringStatus$reflection(), string_type)], ["UserValues", BarringStatus$reflection()], ["SaveStatus", SaveStatus$reflection()], ["SaveBarringStatusFn", lambda_type(BarringStatus$reflection(), unit_type)], ["ResetSaveStatusFn", lambda_type(unit_type, unit_type)], ["SetIsEditingFn", lambda_type(bool_type, unit_type)]]);
}

const renderBarring = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_14, children_17, children_26, props_25, children_24, props_23, children_22;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const matchValue = props.ServerValues;
    switch (matchValue.tag) {
        case 1: {
            return loadingBoxHtml;
        }
        case 3: {
            return renderErrorBox(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Barring"), matchValue.fields[0]);
        }
        case 2: {
            const renderRow = (label, status$0027, onClick) => {
                let children_6, inputRecord;
                if (status$0027 != null) {
                    const status = status$0027;
                    const boolStr = status ? getTranslation("Common.On") : getTranslation("Common.Off");
                    const switchClasses = classNames(singleton_2(["barring__switch", true]));
                    const props_9 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "justify-content-between", "mb-2", "position-relative"])))];
                    const children_8 = [react.createElement("span", {}, label), (children_6 = [react.createElement("span", {
                        className: "mr-3",
                    }, boolStr), render_3((inputRecord = SwitchProps_get_GetDefault(), new SwitchProps(toText(printf("barring-switch-%s"))(label), status, onClick, !props.IsEditing)))], react.createElement("span", {
                        className: switchClasses,
                    }, ...children_6))];
                    return react.createElement("div", keyValueList(props_9, 1), ...children_8);
                }
                else {
                    return react.createElement(react.Fragment, {});
                }
            };
            let rowsHtml;
            const emptyBarringStatus = new BarringStatus(void 0, void 0, void 0, void 0, void 0, void 0, false);
            const children_11 = toList(delay(() => append(singleton(renderRow(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Locked"), props.UserValues.Locked, (_arg) => {
                props.SaveBarringStatusFn(new BarringStatus(emptyBarringStatus.InternationalOut, !value_8(props.UserValues.Locked), emptyBarringStatus.Outgoing, emptyBarringStatus.Premium, emptyBarringStatus.Roaming, emptyBarringStatus.Topup, emptyBarringStatus.TopupEnabled));
            })), delay(() => append(singleton(renderRow(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.InternationalOut"), props.UserValues.InternationalOut, (_arg_1) => {
                props.SaveBarringStatusFn(new BarringStatus(!value_8(props.UserValues.InternationalOut), emptyBarringStatus.Locked, emptyBarringStatus.Outgoing, emptyBarringStatus.Premium, emptyBarringStatus.Roaming, emptyBarringStatus.Topup, emptyBarringStatus.TopupEnabled));
            })), delay(() => append(singleton(renderRow(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Outgoing"), props.UserValues.Outgoing, (_arg_2) => {
                props.SaveBarringStatusFn(new BarringStatus(emptyBarringStatus.InternationalOut, emptyBarringStatus.Locked, !value_8(props.UserValues.Outgoing), emptyBarringStatus.Premium, emptyBarringStatus.Roaming, emptyBarringStatus.Topup, emptyBarringStatus.TopupEnabled));
            })), delay(() => append(singleton(renderRow("Premium", props.UserValues.Premium, (_arg_3) => {
                props.SaveBarringStatusFn(new BarringStatus(emptyBarringStatus.InternationalOut, emptyBarringStatus.Locked, emptyBarringStatus.Outgoing, !value_8(props.UserValues.Premium), emptyBarringStatus.Roaming, emptyBarringStatus.Topup, emptyBarringStatus.TopupEnabled));
            })), delay(() => append(singleton(renderRow("Roaming", props.UserValues.Roaming, (_arg_4) => {
                props.SaveBarringStatusFn(new BarringStatus(emptyBarringStatus.InternationalOut, emptyBarringStatus.Locked, emptyBarringStatus.Outgoing, emptyBarringStatus.Premium, !value_8(props.UserValues.Roaming), emptyBarringStatus.Topup, emptyBarringStatus.TopupEnabled));
            })), delay(() => (props.UserValues.TopupEnabled ? singleton(renderRow("Topup", props.UserValues.Topup, (_arg_5) => {
                props.SaveBarringStatusFn(new BarringStatus(emptyBarringStatus.InternationalOut, emptyBarringStatus.Locked, emptyBarringStatus.Outgoing, emptyBarringStatus.Premium, emptyBarringStatus.Roaming, !value_8(props.UserValues.Topup), emptyBarringStatus.TopupEnabled));
            })) : singleton(react.createElement(react.Fragment, {})))))))))))))));
            rowsHtml = react.createElement("div", {}, ...children_11);
            let errorModalHtml;
            const matchValue_1 = props.SaveStatus;
            errorModalHtml = ((matchValue_1.tag === 3) ? renderErrorModal(getTranslation, matchValue_1.fields[0].split(""), (_arg_6) => {
                props.ResetSaveStatusFn();
            }) : react.createElement(react.Fragment, {}));
            let editButtonHtml;
            const onClickFn = props.IsEditing ? ((_arg_7) => {
                props.SetIsEditingFn(false);
            }) : ((_arg_8) => {
                props.SetIsEditingFn(true);
            });
            let buttonTextHtml;
            if (props.IsEditing) {
                const children_16 = [renderSveaIconBySize(new SveaIcon(6), new Size(0)), (children_14 = [getTranslation("Common.Cancel")], react.createElement("span", {
                    className: "barring__pen-text",
                }, ...children_14))];
                buttonTextHtml = react.createElement(react.Fragment, {}, ...children_16);
            }
            else {
                const children_19 = [renderSveaIconBySize(new SveaIcon(5), new Size(0)), (children_17 = [getTranslation("Common.Change")], react.createElement("span", {
                    className: "barring__pen-text",
                }, ...children_17))];
                buttonTextHtml = react.createElement(react.Fragment, {}, ...children_19);
            }
            const props_21 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "pointer"]))), new DOMAttr(40, onClickFn)];
            editButtonHtml = react.createElement("div", keyValueList(props_21, 1), buttonTextHtml);
            const props_29 = [new HTMLAttr(65, stackClasses(ofArray(["simple-order__container", "barring"])))];
            const children_28 = [(children_26 = [(props_25 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between", "align-items-center", "mb-3"])))], (children_24 = [(props_23 = [new HTMLAttr(65, stackClasses(ofArray(["mb-0", "font-weight-bold"]))), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Telecom.Barring"]], (children_22 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Barring")], react.createElement("h6", keyValueList(props_23, 1), ...children_22))), editButtonHtml], react.createElement("div", keyValueList(props_25, 1), ...children_24))), rowsHtml], react.createElement("div", {
                className: "container__actions",
            }, ...children_26)), errorModalHtml];
            return react.createElement("div", keyValueList(props_29, 1), ...children_28);
        }
        default: {
            return react.createElement(react.Fragment, {});
        }
    }
}, "BarringBox", Helpers_equalsButFunctions, void 0, "renderBarring", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 765);

class ChangeSimCardProps extends Record {
    constructor(ChangeIccSaveStatus, SaveIccFn, ResetVMFn, Sim, LoadIccNumbersFn, GetIccSuggestionsFn, ValidateIcc, ValidateIccFn, ValidateIccResetFn, NetworkContractNr) {
        super();
        this.ChangeIccSaveStatus = ChangeIccSaveStatus;
        this.SaveIccFn = SaveIccFn;
        this.ResetVMFn = ResetVMFn;
        this.Sim = Sim;
        this.LoadIccNumbersFn = LoadIccNumbersFn;
        this.GetIccSuggestionsFn = GetIccSuggestionsFn;
        this.ValidateIcc = ValidateIcc;
        this.ValidateIccFn = ValidateIccFn;
        this.ValidateIccResetFn = ValidateIccResetFn;
        this.NetworkContractNr = NetworkContractNr;
    }
}

function ChangeSimCardProps$reflection() {
    return record_type("Containers.SimpleOrder.View.ChangeSimCardProps", [], ChangeSimCardProps, () => [["ChangeIccSaveStatus", SaveStatus$reflection()], ["SaveIccFn", lambda_type(string_type, unit_type)], ["ResetVMFn", lambda_type(unit_type, unit_type)], ["Sim", Sim$reflection()], ["LoadIccNumbersFn", lambda_type(unit_type, unit_type)], ["GetIccSuggestionsFn", option_type(lambda_type(string_type, array_type(string_type)))], ["ValidateIcc", LoadState$2$reflection(ValidateIcc$reflection(), string_type)], ["ValidateIccFn", lambda_type(string_type, unit_type)], ["ValidateIccResetFn", lambda_type(unit_type, unit_type)], ["NetworkContractNr", option_type(int32_type)]]);
}

const renderChangeSimCard = FunctionComponent_Of_Z5A158BBF((props) => {
    let inputRecord, matchValue_3, inputRecord_3, arg_8, arg_7, arg_10, arg_9, arg_11, children_26, props_25, children_24;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const modalIsOpenState = react.useState(false);
    const inputIccState = react.useState("");
    const inputIccIsFocusedState = react.useState(false);
    const resetModalState = () => {
        modalIsOpenState[1](false);
        inputIccState[1]("");
        inputIccIsFocusedState[1](false);
        props.ValidateIccResetFn();
    };
    let modalHtml;
    const matchValue = modalIsOpenState[0];
    if (matchValue) {
        let bodyHtml;
        const iccInputHtml = render_2()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(inputIccState[0], inputRecord.Type, inputRecord.Classes, (e) => {
            const arg = Browser_Types_Event__Event_get_Value(e);
            inputIccState[1](arg);
            if (props.ValidateIcc.tag === 0) {
            }
            else {
                props.ValidateIccResetFn();
            }
        }, inputRecord.Disabled, getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.NewIcc"), "new-icc-input", (str) => IccModule_create(getTranslation, str), inputRecord.DynamicWidth, inputRecord.HTMLProps, (_arg_1) => {
            startImmediate(delayAsync(100, () => {
                inputIccIsFocusedState[1](false);
            }));
        }, (_arg) => {
            inputIccIsFocusedState[1](true);
        }, inputRecord.AutoComplete, inputRecord.Name)));
        let iccSuggestionsHtml;
        const matchValue_2 = inputIccIsFocusedState[0];
        iccSuggestionsHtml = (matchValue_2 ? renderIccSuggestions({
            GetIccSuggestionsFn: props.GetIccSuggestionsFn,
            IccValue: inputIccState[0],
            OnClick: (number) => {
                inputIccState[1](number);
                inputIccIsFocusedState[1](false);
            },
        }) : react.createElement(react.Fragment, {}));
        const validateIccHtml = renderIccValidation({
            IccValue: inputIccState[0],
            ValidateIcc: props.ValidateIcc,
            ValidateIccFn: props.ValidateIccFn,
        });
        bodyHtml = react.createElement("div", {
            className: "container__change-icc",
        }, iccInputHtml, iccSuggestionsHtml, validateIccHtml);
        let cancelButtonProps;
        const inputRecord_1 = ButtonProps_get_getDefault();
        cancelButtonProps = (new ButtonProps(getTranslation("Common.Cancel"), inputRecord_1.Content, (_arg_2) => {
            resetModalState();
        }, inputRecord_1.Disabled, inputRecord_1.Id, inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon));
        let acceptButtonProps;
        const inputRecord_2 = ButtonProps_get_getDefault();
        acceptButtonProps = (new ButtonProps(getTranslation("Common.Change"), inputRecord_2.Content, (_arg_3) => {
            props.SaveIccFn(inputIccState[0]);
            resetModalState();
        }, (matchValue_3 = props.ValidateIcc, (matchValue_3.tag === 2) ? (!matchValue_3.fields[0].IsSuccess) : true), inputRecord_2.Id, inputRecord_2.SaveStatus, inputRecord_2.HTMLProps, inputRecord_2.ExtraClasses, inputRecord_2.Icon));
        modalHtml = renderWithButtonProps(modalIsOpenState[0], new ModalSize(1), getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ChangeSimCard"), bodyHtml, cancelButtonProps, acceptButtonProps);
    }
    else {
        modalHtml = react.createElement(react.Fragment, {});
    }
    const openChangeIccModalButtonHtml = main((inputRecord_3 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ChangeSimCard"), inputRecord_3.Content, (_arg_4) => {
        modalIsOpenState[1](true);
        props.LoadIccNumbersFn();
    }, props.NetworkContractNr == null, "open-save-icc-modal-button", props.ChangeIccSaveStatus, (props.NetworkContractNr == null) ? singleton_2(new HTMLAttr(158, "NetworkContractNr missing.")) : empty(), inputRecord_3.ExtraClasses, inputRecord_3.Icon)));
    let errorModalHtml;
    const matchValue_5 = props.ChangeIccSaveStatus;
    errorModalHtml = ((matchValue_5.tag === 3) ? renderErrorModal(getTranslation, matchValue_5.fields[0].split(""), (_arg_5) => {
        props.ResetVMFn();
    }) : react.createElement(react.Fragment, {}));
    let simInfoSectionHtml;
    let iccHtml;
    const children_5 = [toText(printf("ICC: %s"))(props.Sim.Icc)];
    iccHtml = react.createElement("div", {}, ...children_5);
    let imsiHtml;
    const children_7 = [toText(printf("IMSI: %d"))(props.Sim.Imsi)];
    imsiHtml = react.createElement("div", {}, ...children_7);
    let pinHtml;
    const children_9 = [toText(printf("PIN: %s"))(props.Sim.Pin)];
    pinHtml = react.createElement("div", {}, ...children_9);
    let pukHtml;
    const children_11 = [toText(printf("PUK: %s"))(props.Sim.Puk)];
    pukHtml = react.createElement("div", {}, ...children_11);
    let modelHtml;
    const children_13 = [(arg_8 = defaultArg(props.Sim.Model, "-"), (arg_7 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Model"), toText(printf("%s: %s"))(arg_7)(arg_8)))];
    modelHtml = react.createElement("div", {}, ...children_13);
    let brandHtml;
    const children_15 = [(arg_10 = defaultArg(props.Sim.Brand, "-"), (arg_9 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Brand"), toText(printf("%s: %s"))(arg_9)(arg_10)))];
    brandHtml = react.createElement("div", {}, ...children_15);
    let simTypeCodeHtml;
    const children_17 = [(arg_11 = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SimTypeCode"), toText(printf("%s: %s"))(arg_11)(props.Sim.SimTypeCode))];
    simTypeCodeHtml = react.createElement("div", {}, ...children_17);
    let packageNumberHtml;
    const matchValue_6 = props.Sim.PackageNumber;
    if (matchValue_6 != null) {
        const packageNumber = matchValue_6;
        const children_20 = [toText(printf("Nummersatt: %s"))(packageNumber)];
        packageNumberHtml = react.createElement("div", {}, ...children_20);
    }
    else {
        packageNumberHtml = react.createElement(react.Fragment, {});
    }
    simInfoSectionHtml = react.createElement("div", {}, pinHtml, pukHtml, iccHtml, imsiHtml, simTypeCodeHtml, packageNumberHtml, brandHtml, modelHtml);
    const containerClasses = stackClasses(ofArray(["simple-order__container", "simple-order__set-height", "justify-content-between"]));
    const children_30 = [(children_26 = [(props_25 = [new HTMLAttr(65, stackClasses(ofArray(["mb-3", "font-weight-bold"]))), ["data-translation", "Common.SimCard"]], (children_24 = [getTranslation("Common.SimCard")], react.createElement("h6", keyValueList(props_25, 1), ...children_24))), simInfoSectionHtml], react.createElement("div", {}, ...children_26)), react.createElement("div", {}, openChangeIccModalButtonHtml, modalHtml), errorModalHtml];
    return react.createElement("div", {
        className: containerClasses,
    }, ...children_30);
}, "ChangeSimCardBox", Helpers_equalsButFunctions, void 0, "renderChangeSimCard", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 958);

export class SimpleOrderProps extends Record {
    constructor(GlobalDependencies, ContractNr, Product, NetworkContractNr, ReloadContracts, ActivePhoneNumbers) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.Product = Product;
        this.NetworkContractNr = NetworkContractNr;
        this.ReloadContracts = ReloadContracts;
        this.ActivePhoneNumbers = ActivePhoneNumbers;
    }
}

export function SimpleOrderProps$reflection() {
    return record_type("Containers.SimpleOrder.View.SimpleOrderProps", [], SimpleOrderProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["Product", option_type(Product$reflection())], ["NetworkContractNr", option_type(int32_type)], ["ReloadContracts", lambda_type(unit_type, unit_type)], ["ActivePhoneNumbers", list_type(string_type)]]);
}

export const renderSimpleOrder = FunctionComponent_Of_Z5A158BBF((props) => {
    let number_7, sim, children_9;
    const simState = react.useState(new LoadState$2(0));
    const providerServicesState = react.useState(new LoadState$2(0));
    const numberHistoryState = react.useState(new LoadState$2(0));
    const selectedNumberHistoryState = react.useState(void 0);
    const numberState = react.useState(new LoadState$2(0));
    const activationSaveState = react.useState(new SaveStatus_5(0));
    const changeIccSaveState = react.useState(new SaveStatus_5(0));
    const iccTrieState = react.useState(new LoadState$2(0));
    let getSuggestionsOpt;
    const matchValue = iccTrieState[0];
    switch (matchValue.tag) {
        case 1:
        case 3: {
            getSuggestionsOpt = (void 0);
            break;
        }
        case 2: {
            getSuggestionsOpt = ((input) => {
                const suggestions = toArray(map_3((chars) => join("", chars), Trie_getSuggestions(input.split(""), matchValue.fields[0])));
                const maxSuggestions = 10;
                let endIndex;
                const arrayMaxIndex = (suggestions.length - 1) | 0;
                endIndex = ((maxSuggestions > arrayMaxIndex) ? arrayMaxIndex : maxSuggestions);
                return suggestions.slice(0, endIndex + 1);
            });
            break;
        }
        default: {
            getSuggestionsOpt = (void 0);
        }
    }
    const iccValidateState = react.useState(new LoadState$2(0));
    let topupVMState;
    const arg_1 = new TopupViewModel(new LoadState$2(0), new LoadState$2(0), "", new SaveStatus_5(0));
    topupVMState = react.useState(arg_1);
    let dataPackageVMState;
    const arg_2 = new DataPackageViewModel(new LoadState$2(0), new LoadState$2(0), new LoadState$2(0), "", new SaveStatus_5(0));
    dataPackageVMState = react.useState(arg_2);
    let barringVMState;
    const arg_3 = new BarringViewModel(false, new LoadState$2(0), new BarringStatus(void 0, void 0, void 0, void 0, void 0, void 0, false), new SaveStatus_5(0));
    barringVMState = react.useState(arg_3);
    const loadIccNumbers = () => {
        iccTrieState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(Api_loadIccNumbers(props.GlobalDependencies.ClientNr), (_arg) => {
            const result = _arg;
            const arg_6 = (result.tag === 1) ? (new LoadState$2(3, result.fields[0])) : (new LoadState$2(2, fold((acc, curr) => Trie_add(curr.split(""), acc), Trie_empty(), result.fields[0])));
            iccTrieState[1](arg_6);
            return singleton_1.Zero();
        })));
    };
    const loadIccValidate = (icc) => {
        loadEffect(() => Api_loadValidateIcc(props.GlobalDependencies.ClientNr, icc), (arg_8) => {
            iccValidateState[1](arg_8);
        });
    };
    const barringLoadStatus = (number_6) => {
        barringVMState[1]((x_18) => (new BarringViewModel(x_18.IsEditing, new LoadState$2(1), x_18.UserValues, x_18.SaveStatus)));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(BarringApi_loadStatus(props.GlobalDependencies.ClientNr, props.ContractNr, number_6), (_arg_7) => {
            const result_7 = _arg_7;
            if (result_7.tag === 1) {
                barringVMState[1]((x_20) => (new BarringViewModel(x_20.IsEditing, new LoadState$2(3, result_7.fields[0]), x_20.UserValues, x_20.SaveStatus)));
                return singleton_1.Zero();
            }
            else {
                const barringStatus = result_7.fields[0];
                barringVMState[1]((x_19) => (new BarringViewModel(x_19.IsEditing, new LoadState$2(2, barringStatus), barringStatus, x_19.SaveStatus)));
                return singleton_1.Zero();
            }
        })));
    };
    const loadNumberHistory = () => {
        numberHistoryState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(Api_loadNumberHistory(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_10) => {
            const result_10 = _arg_10;
            let arg_28;
            if (result_10.tag === 1) {
                arg_28 = (new LoadState$2(3, result_10.fields[0]));
            }
            else {
                const numberHistories = mapIndexed(NumberHistory_OfDTO, NumberHistoryDTO_SortByActiveFrom_285C6A16(result_10.fields[0]));
                const matchValue_5 = tryHead(numberHistories);
                if (matchValue_5 != null) {
                    const numberHistory = matchValue_5;
                    selectedNumberHistoryState[1](numberHistory);
                }
                arg_28 = (new LoadState$2(2, numberHistories));
            }
            numberHistoryState[1](arg_28);
            return singleton_1.Zero();
        })));
    };
    react.useEffect(() => {
        loadNumberHistory();
    }, [props.GlobalDependencies, props.ContractNr]);
    react.useEffect(() => {
        defaultArg(map_1((imsi_1) => {
            loadEffect(() => Api_loadSim(props.GlobalDependencies.ClientNr, imsi_1), (arg_4) => {
                simState[1](arg_4);
            });
        }, bind((nh) => nh.Imsi, selectedNumberHistoryState[0])), void 0);
        providerServicesState[1](new LoadState$2(1));
        startImmediate(singleton_1.Delay(() => singleton_1.Bind(Api_loadProviderServices(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_9) => {
            const result_9 = _arg_9;
            let arg_23;
            if (result_9.tag === 1) {
                arg_23 = (new LoadState$2(3, result_9.fields[0]));
            }
            else if (result_9.fields[0] == null) {
                arg_23 = (new LoadState$2(3, "[SimpleOrder - LoadedProviderServices] No available Provider Services."));
            }
            else {
                const providerServices = ProviderServices_OfDto_Z4FEEBB20(result_9.fields[0]);
                iterate((fn) => {
                    fn();
                }, map_2((serviceCall) => {
                    const matchValue_3 = selectedNumberHistoryState[0];
                    if (matchValue_3 != null) {
                        const selectedNumberHistory = matchValue_3;
                        const matchValue_4 = tryFind((phoneNr) => (phoneNr === selectedNumberHistory.NumberFrom), props.ActivePhoneNumbers);
                        if (matchValue_4 != null) {
                            const activePhoneNumber = matchValue_4;
                            switch (serviceCall.tag) {
                                case 1: {
                                    return () => {
                                        topupVMState[1]((x_2) => (new TopupViewModel(x_2.Usage, new LoadState$2(1), x_2.SelectedPackage, x_2.PackageSaveStatus)));
                                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(TopupApi_loadPackages(props.GlobalDependencies.ClientNr, props.ContractNr, activePhoneNumber), (_arg_2) => {
                                            const result_2 = _arg_2;
                                            if (result_2.tag === 1) {
                                                topupVMState[1]((x_4) => (new TopupViewModel(x_4.Usage, new LoadState$2(3, result_2.fields[0]), x_4.SelectedPackage, x_4.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                            else {
                                                topupVMState[1]((x_3) => (new TopupViewModel(x_3.Usage, new LoadState$2(2, result_2.fields[0]), x_3.SelectedPackage, x_3.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                        })));
                                    };
                                }
                                case 2: {
                                    return () => {
                                        topupVMState[1]((x_5) => (new TopupViewModel(new LoadState$2(1), x_5.Packages, x_5.SelectedPackage, x_5.PackageSaveStatus)));
                                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(TopupApi_loadUsage(props.GlobalDependencies.ClientNr, props.ContractNr, activePhoneNumber), (_arg_3) => {
                                            const result_3 = _arg_3;
                                            if (result_3.tag === 1) {
                                                topupVMState[1]((x_7) => (new TopupViewModel(new LoadState$2(3, result_3.fields[0]), x_7.Packages, x_7.SelectedPackage, x_7.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                            else {
                                                topupVMState[1]((x_6) => (new TopupViewModel(new LoadState$2(2, result_3.fields[0]), x_6.Packages, x_6.SelectedPackage, x_6.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                        })));
                                    };
                                }
                                case 3: {
                                    return () => {
                                        dataPackageVMState[1]((x_12) => (new DataPackageViewModel(new LoadState$2(1), x_12.Usage, x_12.Packages, x_12.SelectedPackage, x_12.PackageSaveStatus)));
                                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(DataPackageApi_loadCurrent(props.GlobalDependencies.ClientNr, props.ContractNr, activePhoneNumber), (_arg_5) => {
                                            const result_5 = _arg_5;
                                            if (result_5.tag === 1) {
                                                dataPackageVMState[1]((x_14) => (new DataPackageViewModel(new LoadState$2(3, result_5.fields[0]), x_14.Usage, x_14.Packages, x_14.SelectedPackage, x_14.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                            else {
                                                dataPackageVMState[1]((x_13) => (new DataPackageViewModel(new LoadState$2(2, result_5.fields[0]), x_13.Usage, x_13.Packages, x_13.SelectedPackage, x_13.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                        })));
                                    };
                                }
                                case 4: {
                                    return () => {
                                        dataPackageVMState[1]((x_15) => (new DataPackageViewModel(x_15.CurrentPackage, new LoadState$2(1), x_15.Packages, x_15.SelectedPackage, x_15.PackageSaveStatus)));
                                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(DataPackageApi_loadUsage(props.GlobalDependencies.ClientNr, props.ContractNr, activePhoneNumber), (_arg_6) => {
                                            const result_6 = _arg_6;
                                            if (result_6.tag === 1) {
                                                dataPackageVMState[1]((x_17) => (new DataPackageViewModel(x_17.CurrentPackage, new LoadState$2(3, result_6.fields[0]), x_17.Packages, x_17.SelectedPackage, x_17.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                            else {
                                                dataPackageVMState[1]((x_16) => (new DataPackageViewModel(x_16.CurrentPackage, new LoadState$2(2, result_6.fields[0]), x_16.Packages, x_16.SelectedPackage, x_16.PackageSaveStatus)));
                                                return singleton_1.Zero();
                                            }
                                        })));
                                    };
                                }
                                case 5: {
                                    return () => {
                                        barringLoadStatus(activePhoneNumber);
                                    };
                                }
                                default: {
                                    return () => {
                                        startImmediate(singleton_1.Delay(() => singleton_1.Bind(GeneralApi_loadAllStatuses(props.GlobalDependencies.ClientNr, props.ContractNr, activePhoneNumber), (_arg_1) => {
                                            const result_1 = _arg_1;
                                            let arg_11;
                                            if (result_1.tag === 1) {
                                                arg_11 = (new LoadState$2(3, result_1.fields[0]));
                                            }
                                            else {
                                                const numberState_1 = result_1.fields[0];
                                                const mbToB = (mb) => fromNumber(toNumber(op_Multiply(new Decimal(mb), Byte_get_BytesPerMegaByte())), false);
                                                let topupUsage;
                                                const matchValue_1 = numberState_1.ReadOnlyTopup;
                                                if (matchValue_1 == null) {
                                                    topupUsage = (new LoadState$2(3, "[LoadedNumberState] No cached values for Topup Usage."));
                                                }
                                                else {
                                                    const topup = matchValue_1;
                                                    topupUsage = (new LoadState$2(2, new TopupUsage(map_1(mbToB, topup.LimitInMb), map_1(mbToB, topup.RemainingInMb), DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffffffZ(now()))));
                                                }
                                                topupVMState[1]((x) => (new TopupViewModel(topupUsage, x.Packages, x.SelectedPackage, x.PackageSaveStatus)));
                                                let dataPackageUsage;
                                                const matchValue_2 = numberState_1.ReadOnlyDatapackage;
                                                if (matchValue_2 == null) {
                                                    dataPackageUsage = (new LoadState$2(3, "[LoadedNumberState] No cached values for DataPackage Usage."));
                                                }
                                                else {
                                                    const datapackage = matchValue_2;
                                                    dataPackageUsage = (new LoadState$2(2, new DataPackageUsage(empty(), map_1(mbToB, datapackage.LimitInMb), map_1(mbToB, datapackage.RemainingInMb), void 0, map_1(mbToB, datapackage.RolloverInMb), DateTimeExtensions_yyyy_MM_ddTHH_mm_ss_fffffffZ(now()))));
                                                }
                                                dataPackageVMState[1]((x_1) => (new DataPackageViewModel(x_1.CurrentPackage, dataPackageUsage, x_1.Packages, x_1.SelectedPackage, x_1.PackageSaveStatus)));
                                                arg_11 = (new LoadState$2(2, numberState_1));
                                            }
                                            numberState[1](arg_11);
                                            return singleton_1.Zero();
                                        })));
                                    };
                                }
                            }
                        }
                        else {
                            return () => {
                            };
                        }
                    }
                    else {
                        return () => {
                        };
                    }
                }, List_distinct(collect(ProviderServices_GetServiceKind_50594B0D, providerServices.Implements), {
                    Equals: equals_1,
                    GetHashCode: safeHash,
                })));
                arg_23 = (new LoadState$2(2, providerServices));
            }
            providerServicesState[1](arg_23);
            return singleton_1.Zero();
        })));
    }, [selectedNumberHistoryState[0]]);
    let usesProvisioningViaSvea;
    const matchValue_6 = providerServicesState[0];
    usesProvisioningViaSvea = ((matchValue_6.tag === 2) && usesProvisioningViaSvea_1(matchValue_6.fields[0].NetworkContract.NetworkIntegrationNr));
    const hasService = (providerServicesLoadState, service) => {
        if (providerServicesLoadState.tag === 2) {
            return exists((s) => equals_1(s, service), providerServicesLoadState.fields[0].Implements);
        }
        else {
            return false;
        }
    };
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    let dataBoxHtml;
    const matchValue_7 = selectedNumberHistoryState[0];
    if (matchValue_7 != null) {
        const number_10 = matchValue_7;
        const matchValue_8 = [props.NetworkContractNr != null, NumberHistory_IsActive_Z5E3A5CDD(number_10), usesProvisioningViaSvea, hasService(providerServicesState[0], new Service(1)) ? true : hasService(providerServicesState[0], new Service(2))];
        let pattern_matching_result;
        if (matchValue_8[0]) {
            if (matchValue_8[1]) {
                if (matchValue_8[2]) {
                    if (matchValue_8[3]) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                dataBoxHtml = renderDataBox(new DataBoxProps((dataPackageVMState[0]).CurrentPackage, (dataPackageVMState[0]).Usage, (dataPackageVMState[0]).Packages, (dataPackageVMState[0]).SelectedPackage, (dataPackageVMState[0]).PackageSaveStatus, (topupVMState[0]).Usage, (topupVMState[0]).Packages, (topupVMState[0]).SelectedPackage, (topupVMState[0]).PackageSaveStatus, props.GlobalDependencies.CountryCode, (package$) => {
                    topupVMState[1]((x_8) => (new TopupViewModel(x_8.Usage, x_8.Packages, x_8.SelectedPackage, new SaveStatus_5(1))));
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(TopupApi_savePackage(props.GlobalDependencies.ClientNr, props.ContractNr, number_10.NumberFrom, package$), (_arg_4) => {
                        const result_4 = _arg_4;
                        return singleton_1.Combine((result_4.tag === 1) ? ((topupVMState[1]((x_10) => (new TopupViewModel(x_10.Usage, x_10.Packages, x_10.SelectedPackage, new SaveStatus_5(3, result_4.fields[0])))), singleton_1.Zero())) : ((topupVMState[1]((x_9) => (new TopupViewModel(x_9.Usage, x_9.Packages, x_9.SelectedPackage, new SaveStatus_5(2)))), singleton_1.Zero())), singleton_1.Delay(() => {
                            startImmediate(delayAsync(5000, () => {
                                topupVMState[1]((x_11) => (new TopupViewModel(x_11.Usage, x_11.Packages, x_11.SelectedPackage, new SaveStatus_5(0))));
                            }));
                            return singleton_1.Zero();
                        }));
                    })));
                }, () => {
                    topupVMState[1]((x_26) => (new TopupViewModel(x_26.Usage, x_26.Packages, x_26.SelectedPackage, new SaveStatus_5(0))));
                }));
                break;
            }
            case 1: {
                dataBoxHtml = react.createElement(react.Fragment, {});
                break;
            }
        }
    }
    else {
        dataBoxHtml = react.createElement(react.Fragment, {});
    }
    let activationHtml;
    const matchValue_9 = [props.NetworkContractNr != null, hasService(providerServicesState[0], new Service(0)), usesProvisioningViaSvea];
    let pattern_matching_result_1;
    if (matchValue_9[0]) {
        if (matchValue_9[1]) {
            if (matchValue_9[2]) {
                pattern_matching_result_1 = 0;
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
    }
    else {
        pattern_matching_result_1 = 1;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            activationHtml = renderActivation(new ActivationProps(props.GlobalDependencies.ClientNr, locale, getSuggestionsOpt, iccValidateState[0], loadIccValidate, () => {
                iccValidateState[1](new LoadState$2(0));
            }, (tupledArg) => {
                const body = new MobileApi_ActivateBody(DateTimeExtensions_toIso8601(tupledArg[2]), new MobileApi_Item(void 0));
                activationSaveState[1](new SaveStatus_5(1));
                startImmediate(singleton_1.Delay(() => singleton_1.Bind(MobileApi_saveActivateWithIcc(props.GlobalDependencies.ClientNr, props.ContractNr, tupledArg[0], tupledArg[1], body), (_arg_11) => {
                    const result_11 = _arg_11;
                    let arg_32;
                    if (result_11.tag === 1) {
                        arg_32 = (new SaveStatus_5(3, result_11.fields[0]));
                    }
                    else {
                        startImmediate(delayAsync(5000, () => {
                            activationSaveState[1](new SaveStatus_5(0));
                        }));
                        startImmediate(delayAsync(5000, () => {
                            loadNumberHistory();
                        }));
                        props.ReloadContracts();
                        arg_32 = (new SaveStatus_5(2));
                    }
                    activationSaveState[1](arg_32);
                    return singleton_1.Zero();
                })));
            }, loadIccNumbers, activationSaveState[0]));
            break;
        }
        case 1: {
            activationHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    let barringHtml;
    const matchValue_10 = selectedNumberHistoryState[0];
    if (matchValue_10 != null) {
        const number_12 = matchValue_10;
        const matchValue_11 = [props.NetworkContractNr != null, usesProvisioningViaSvea, NumberHistory_IsActive_Z5E3A5CDD(number_12), hasService(providerServicesState[0], new Service(3))];
        let pattern_matching_result_2;
        if (matchValue_11[0]) {
            if (matchValue_11[1]) {
                if (matchValue_11[2]) {
                    if (matchValue_11[3]) {
                        pattern_matching_result_2 = 0;
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
            }
            else {
                pattern_matching_result_2 = 1;
            }
        }
        else {
            pattern_matching_result_2 = 1;
        }
        switch (pattern_matching_result_2) {
            case 0: {
                barringHtml = renderBarring(new BarringProps((barringVMState[0]).IsEditing, (barringVMState[0]).ServerValues, (barringVMState[0]).UserValues, (barringVMState[0]).SaveStatus, (number_7 = number_12.NumberFrom, (dto) => {
                    barringVMState[1]((x_21) => (new BarringViewModel(x_21.IsEditing, x_21.ServerValues, x_21.UserValues, new SaveStatus_5(1))));
                    startImmediate(singleton_1.Delay(() => singleton_1.Bind(BarringApi_saveStatus(props.GlobalDependencies.ClientNr, props.ContractNr, number_7, dto), (_arg_8) => {
                        const result_8 = _arg_8;
                        if (result_8.tag === 1) {
                            barringVMState[1]((x_24) => (new BarringViewModel(x_24.IsEditing, x_24.ServerValues, x_24.UserValues, new SaveStatus_5(3, result_8.fields[0]))));
                            return singleton_1.Zero();
                        }
                        else {
                            barringLoadStatus(number_7);
                            props.ReloadContracts();
                            startImmediate(delayAsync(1000, () => {
                                barringVMState[1]((x_22) => (new BarringViewModel(x_22.IsEditing, x_22.ServerValues, x_22.UserValues, new SaveStatus_5(0))));
                            }));
                            barringVMState[1]((x_23) => (new BarringViewModel(x_23.IsEditing, x_23.ServerValues, x_23.UserValues, new SaveStatus_5(2))));
                            return singleton_1.Zero();
                        }
                    })));
                }), () => {
                    barringVMState[1]((x_27) => (new BarringViewModel(x_27.IsEditing, x_27.ServerValues, x_27.UserValues, new SaveStatus_5(0))));
                }, (isEditing) => {
                    barringVMState[1]((x_28) => (new BarringViewModel(isEditing, x_28.ServerValues, x_28.UserValues, x_28.SaveStatus)));
                }));
                break;
            }
            case 1: {
                barringHtml = react.createElement(react.Fragment, {});
                break;
            }
        }
    }
    else {
        barringHtml = react.createElement(react.Fragment, {});
    }
    let changeIccHtml;
    const matchValue_12 = selectedNumberHistoryState[0];
    if (matchValue_12 != null) {
        const number_13 = matchValue_12;
        if (NumberHistory_IsActive_Z5E3A5CDD(number_13)) {
            const matchValue_14 = simState[0];
            changeIccHtml = ((matchValue_14.tag === 1) ? dotsLoading : ((matchValue_14.tag === 3) ? error(matchValue_14.fields[0].split("")) : ((matchValue_14.tag === 2) ? ((matchValue_14.fields[0] != null) ? ((sim = matchValue_14.fields[0], renderChangeSimCard(new ChangeSimCardProps(changeIccSaveState[0], (icc_2) => {
                changeIccSaveState[1](new SaveStatus_5(1));
                startImmediate(singleton_1.Delay(() => singleton_1.Bind(MobileApi_saveChangeIcc(props.GlobalDependencies.ClientNr, props.ContractNr, number_13.NumberFrom, icc_2), (_arg_12) => {
                    const result_12 = _arg_12;
                    let arg_35;
                    if (result_12.tag === 1) {
                        arg_35 = (new SaveStatus_5(3, result_12.fields[0]));
                    }
                    else {
                        startImmediate(delayAsync(5000, () => {
                            changeIccSaveState[1](new SaveStatus_5(0));
                        }));
                        arg_35 = (new SaveStatus_5(2));
                    }
                    changeIccSaveState[1](arg_35);
                    return singleton_1.Zero();
                })));
            }, () => {
                changeIccSaveState[1](new SaveStatus_5(0));
            }, sim, loadIccNumbers, getSuggestionsOpt, iccValidateState[0], loadIccValidate, () => {
                iccValidateState[1](new LoadState$2(0));
            }, props.NetworkContractNr)))) : react.createElement(react.Fragment, {})) : react.createElement(react.Fragment, {}))));
        }
        else {
            changeIccHtml = react.createElement(react.Fragment, {});
        }
    }
    else {
        changeIccHtml = react.createElement(react.Fragment, {});
    }
    const portationBoxHtml = renderPortationBox(new PortationBoxProps(props.GlobalDependencies.ClientNr, props.ContractNr, props.GlobalDependencies.SelectedLanguage, new RenderStyle(1), UTCModule_addMonths(-2, UTCModule_today()), UTCModule_addYears(1, UTCModule_today())));
    let isOldSimCard;
    const matchValue_15 = [simState[0], (dataPackageVMState[0]).Usage, (topupVMState[0]).Usage];
    let pattern_matching_result_3, sim_1;
    if (matchValue_15[0].tag === 2) {
        if (matchValue_15[0].fields[0] != null) {
            if (matchValue_15[1].tag === 3) {
                if (matchValue_15[2].tag === 3) {
                    pattern_matching_result_3 = 0;
                    sim_1 = matchValue_15[0].fields[0];
                }
                else {
                    pattern_matching_result_3 = 1;
                }
            }
            else {
                pattern_matching_result_3 = 1;
            }
        }
        else {
            pattern_matching_result_3 = 1;
        }
    }
    else {
        pattern_matching_result_3 = 1;
    }
    switch (pattern_matching_result_3) {
        case 0: {
            isOldSimCard = ((compare(sim_1.Imsi, fromBits(1553597632, 55883, false)) > 0) && (compare(sim_1.Imsi, fromBits(1554597632, 55883, false)) < 0));
            break;
        }
        case 1: {
            isOldSimCard = false;
            break;
        }
    }
    const matchValue_16 = [usesProvisioningViaSvea, props.NetworkContractNr != null, props.Product];
    let pattern_matching_result_4;
    if (matchValue_16[0]) {
        if (matchValue_16[1]) {
            if (matchValue_16[2] != null) {
                if (matchValue_16[2].tag === 0) {
                    pattern_matching_result_4 = 0;
                }
                else if (matchValue_16[2].tag === 3) {
                    pattern_matching_result_4 = 0;
                }
                else {
                    pattern_matching_result_4 = 1;
                }
            }
            else {
                pattern_matching_result_4 = 1;
            }
        }
        else {
            pattern_matching_result_4 = 1;
        }
    }
    else {
        pattern_matching_result_4 = 1;
    }
    switch (pattern_matching_result_4) {
        case 0: {
            const children_11 = [(children_9 = toList(delay(() => append((!isOldSimCard) ? singleton(dataBoxHtml) : empty_1(), delay(() => append(singleton(changeIccHtml), delay(() => append(singleton(activationHtml), delay(() => append(singleton(barringHtml), delay(() => singleton(portationBoxHtml))))))))))), react.createElement("div", {
                className: "simple-order__boxes",
            }, ...children_9))];
            return react.createElement("div", {
                className: "simple-order",
            }, ...children_11);
        }
        case 1: {
            return react.createElement(react.Fragment, {});
        }
    }
}, void 0, uncurry(2, void 0), void 0, "renderSimpleOrder", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\SimpleOrder\\View.fs", 1479);

